var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Calendar-Edit--Streamline-Core",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Calendar Edit Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar-edit--calendar-date-day-compose-edit-note"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.5 2c-0.26522 0 -0.51957 0.10536 -0.707107 0.29289C0.605357 2.48043 0.5 2.73478 0.5 3v9.5c0 0.2652 0.105357 0.5196 0.292893 0.7071 0.187537 0.1875 0.441887 0.2929 0.707107 0.2929h11c0.2652 0 0.5196 -0.1054 0.7071 -0.2929s0.2929 -0.4419 0.2929 -0.7071V3c0 -0.26522 -0.1054 -0.51957 -0.2929 -0.70711C13.0196 2.10536 12.7652 2 12.5 2h-2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.5 0.5v3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.5 0.5v3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.5 2h5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10 6.86404 5.86842 10.9956 4 11.25l0.26316 -1.86842L8.38596 5.25 10 6.86404Z",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarEdit);
export default __webpack_public_path__ + "static/media/Calendar-Edit.069d7643bcc19a611cc337d695e5c349.svg";
export { ForwardRef as ReactComponent };